import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Feature from '../Feature';

import ResponseRateIcon from './ResponseRateIcon';

import styles from './ResponseRateFeature.module.scss';

const RESPONSE_RATE_FEATURE = 'responseRateFeature';

const STATE_CONFIG = {
  4: {
    stateKey: 'homecard.label.response-rate.high',
    bodyKey: 'property_show.book_now_card.response_rate.high.body',
    dot: '●',
    stateClass: 'response-rate-body__state--high'
  },
  3: {
    stateKey: 'homecard.label.response-rate.medium',
    bodyKey: 'property_show.book_now_card.response_rate.medium.body',
    dot: '●',
    stateClass: 'response-rate-body__state--medium'
  },
  2: {
    stateKey: 'homecard.label.response-rate.low',
    bodyKey: 'property_show.book_now_card.response_rate.low.body',
    dot: '◑',
    stateClass: 'response-rate-body__state--low'
  }
};

const ResponseRateFeature = ({
  responseRateState,
  responseRatePercentage,
  collapsed = true,
  onCollapsedChange = () => {}
}) => {
  const config = STATE_CONFIG[responseRateState];
  if (!config) return null;

  return (
    <Feature
      featureName={RESPONSE_RATE_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderIcon={() => <ResponseRateIcon state={responseRateState} />}
      headerKey="property_show.book_now_card.response_rate.title"
      renderBody={() => (
        <div className={styles['response-rate-body']}>
          <span className={styles['response-rate-body__state']}>
            <span className={styles[config.stateClass]}>{config.dot}</span>
            {' '}
            {trans(config.stateKey)}
          </span>
          <p className={styles['response-rate-body__description']}>
            {trans(config.bodyKey)}
          </p>
          <p className={styles['response-rate-body__description']}>
            {trans('property_show.book_now_card.response_rate.percentage', {
              percentage: responseRatePercentage ?? ''
            })}
          </p>
        </div>
      )}
    />
  );
};

ResponseRateFeature.propTypes = {
  responseRateState: PropTypes.oneOf([2, 3, 4]).isRequired,
  responseRatePercentage: PropTypes.number,
  collapsed: PropTypes.bool,
  onCollapsedChange: PropTypes.func
};

export default ResponseRateFeature;
